<template>
    <LiefengContentOverView :isBack="true" @backClick="backClick">
        <template v-slot:title>
            {{ nameover }}网上家园建设情况总览
            <!-- <Button type="error" @click="downFn">返回</Button> -->
        </template>
        <template v-slot:toolsbarRight></template>
        <template v-slot:contentArea>
            <div class="header-wrapper">
                <div class="header">
                    <Card style="width:320px" class="cards">
                        <div style="text-align:center">
                            <p>
                                总街巷/社数：
                                <span>{{ settled.streetCount }}</span>
                            </p>
                            <p>{{ settled.streetSettledCount }}</p>
                            <p>入驻街巷/社</p>
                        </div>
                    </Card>
                    <Card style="width:320px" class="cards">
                        <div style="text-align:center">
                            <p>
                                总小区数：
                                <span>{{ settled.projectCount }}</span>
                            </p>
                            <p>{{ settled.projectSettledCount }}</p>
                            <p>入驻小区</p>
                        </div>
                    </Card>
                    <Card style="width:320px" class="cards">
                        <div style="text-align:center">
                            <p>
                                总楼栋数：
                                <span>{{ settled.buildingCount }}</span>
                            </p>
                            <p>{{ settled.buildingSettledCount }}</p>
                            <p>入驻楼栋</p>
                        </div>
                    </Card>
                    <Card style="width:320px" class="cards">
                        <div style="text-align:center">
                            <p id="house">
                                <span>实际总户数：{{ settled.houseCount }}</span>
                                <span>初始化户数：{{ settled.initHouseNum }}</span>
                            </p>
                            <p>{{ settled.houseSettledCount }}</p>
                            <p>入驻户数</p>
                        </div>
                    </Card>
                </div>
                <div class="illustrated">
                    <ul>
                        <li>图像说明:</li>
                        <li>
                            小区:
                            <span>
                                <svg t="1621301450974" class="icon iconfont" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="26287" width="16" height="16">
                                    <path
                                        d="M1007.282671 936.766331h-49.964825V316.915824a46.688443 46.688443 0 0 0-23.344221-40.954774L680.258799 128.319089a46.893216 46.893216 0 0 0-70.442212 40.954774v767.492468h-53.241206V47.023862a46.688443 46.688443 0 0 0-20.477387-39.111809A46.074121 46.074121 0 0 0 491.45729 4.021349L94.810302 174.188436a47.09799 47.09799 0 0 0-28.463568 43.207287v719.370608H16.586684a16.586684 16.586684 0 0 0-16.586684 16.586684v54.060301a16.586684 16.586684 0 0 0 16.586684 16.586684h990.695987a16.586684 16.586684 0 0 0 16.586683-16.586684v-54.060301a16.586684 16.586684 0 0 0-16.586683-16.586684zM739.233674 296.028889a16.586684 16.586684 0 0 1 16.586683-16.586683h52.626885a16.586684 16.586684 0 0 1 16.586684 16.586683V348.246226a16.586684 16.586684 0 0 1-16.586684 16.586684h-52.626885a16.586684 16.586684 0 0 1-16.586683-16.586684z m0 132.693468a16.586684 16.586684 0 0 1 16.586683-16.586683h52.626885a16.586684 16.586684 0 0 1 16.586684 16.586683v52.831659a16.586684 16.586684 0 0 1-16.586684 16.586684h-52.626885a16.586684 16.586684 0 0 1-16.586683-16.586684z m0 132.898243a16.586684 16.586684 0 0 1 16.586683-16.586684h52.626885a16.586684 16.586684 0 0 1 16.586684 16.586684V614.452258a16.586684 16.586684 0 0 1-16.586684 16.586684h-52.626885a16.586684 16.586684 0 0 1-16.586683-16.586684z m0 132.693468a16.586684 16.586684 0 0 1 16.586683-16.586684h52.626885a16.586684 16.586684 0 0 1 16.586684 16.586684v52.626885a16.586684 16.586684 0 0 1-16.586684 16.586683h-52.626885a16.586684 16.586684 0 0 1-16.586683-16.586683z m0 132.693468a16.586684 16.586684 0 0 1 16.586683-16.586683h52.626885a16.586684 16.586684 0 0 1 16.586684 16.586683V880.65829a16.586684 16.586684 0 0 1-16.586684 16.586684h-52.626885a16.586684 16.586684 0 0 1-16.586683-16.586684zM348.11558 163.949742a16.791457 16.791457 0 0 1 16.586684-16.791457h52.831659a16.791457 16.791457 0 0 1 16.586683 16.791457v52.626885a16.586684 16.586684 0 0 1-16.586683 16.586684h-53.241207a16.586684 16.586684 0 0 1-16.586683-16.586684z m0 132.693469a16.586684 16.586684 0 0 1 16.586684-16.586684h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586684V348.246226a16.586684 16.586684 0 0 1-16.586683 16.586684h-53.241207A16.586684 16.586684 0 0 1 348.11558 348.246226z m0 132.693468a16.586684 16.586684 0 0 1 16.586684-16.586683h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586683v52.831659a16.791457 16.791457 0 0 1-16.586683 16.586683h-53.241207a16.791457 16.791457 0 0 1-16.586683-16.586683z m0 132.898242a16.586684 16.586684 0 0 1 16.586684-16.586683h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586683V614.452258a16.586684 16.586684 0 0 1-16.586683 16.586684h-53.241207A16.586684 16.586684 0 0 1 348.11558 614.452258z m0 132.693469a16.586684 16.586684 0 0 1 16.586684-16.586684h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586684v52.626884a16.586684 16.586684 0 0 1-16.586683 16.586684h-53.241207a16.586684 16.586684 0 0 1-16.586683-16.586684z m0 132.693468a16.791457 16.791457 0 0 1 16.586684-16.586684h52.831659a16.791457 16.791457 0 0 1 16.586683 16.586684V880.65829a16.791457 16.791457 0 0 1-16.586683 16.586684h-53.241207A16.791457 16.791457 0 0 1 348.11558 880.65829zM188.187187 296.028889a16.38191 16.38191 0 0 1 16.38191-16.586683h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586683V348.246226a16.586684 16.586684 0 0 1-16.586683 16.586684H204.773871a16.38191 16.38191 0 0 1-16.38191-16.586684z m0 132.693468a16.38191 16.38191 0 0 1 16.38191-16.586683h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586683v52.831659a16.586684 16.586684 0 0 1-16.586683 16.586684H204.773871a16.586684 16.586684 0 0 1-16.38191-16.586684z m0 132.898243a16.38191 16.38191 0 0 1 16.38191-16.586684h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586684V614.452258a16.586684 16.586684 0 0 1-16.586683 16.586684H204.773871a16.38191 16.38191 0 0 1-16.38191-16.586684z m0 132.693468a16.38191 16.38191 0 0 1 16.38191-16.586684h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586684v52.626885a16.586684 16.586684 0 0 1-16.586683 16.586683H204.773871a16.38191 16.38191 0 0 1-16.38191-16.586683z m0 132.693468a16.586684 16.586684 0 0 1 16.38191-16.586683h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586683V880.65829a16.586684 16.586684 0 0 1-16.586683 16.586684H204.773871a16.586684 16.586684 0 0 1-16.38191-16.586684z"
                                        p-id="26288"
                                        fill="#68C07C"
                                    ></path>
                                </svg>
                            </span>
                        </li>
                        <li>
                            楼栋:
                            <span>
                                <svg t="1621301538576" class="icon iconfont" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="29231" width="32" height="32">
                                    <path
                                        d="M653.62 920.47H338.69m121.33-539.73h-41.37v81.37h41.37v-81.37z m135.44 0h-41.37v81.37h41.37v-81.37zM460.02 525.83h-41.37v71.37h41.37v-71.37z m135.44 0h-41.37v71.37h41.37v-71.37z m-135.44 131h-41.37v81.37h41.37v-81.37z m135.44 0h-41.37v81.37h41.37v-81.37zM460.02 788.32h-41.37v81.37h41.37v-81.37z m135.44 0h-41.37v81.37h41.37v-81.37z m0 0"
                                        p-id="29232"
                                        fill="#B0B0B0"
                                    ></path>
                                    <path d="M722.02 961.85H277.66V125.54s-0.66-14.43 5.69-21.35c6.34-6.91 26.26-6.82 26.26-6.82l386.2-0.09s15.66-0.46 20.94 6.91c5.28 7.38 4.87 21.76 4.87 21.76v835.9h0.4z m-401.35-41.38h358.34V140.28H320.67v780.19z m0 0" p-id="29233" fill="#B0B0B0"></path>
                                    <path d="M416.65 224.74h41.37v81.37h-41.37zM552.09 224.74h41.37v81.37h-41.37z" p-id="29234" fill="#B0B0B0"></path>
                                    <path d="M249.3 942.85h507.92M757.22 962.85H249.3c-11.05 0-20-8.95-20-20s8.95-20 20-20h507.91c11.05 0 20 8.95 20 20s-8.95 20-19.99 20z" p-id="29235" fill="#B0B0B0"></path>
                                </svg>
                            </span>
                        </li>

                        <li>
                            门牌号:
                            <span class="white" ref="whiteFn"></span>
                            <div class="info">
                                <span>{{ dataList.unSettledCount }}</span>
                                <span>未入驻</span>
                            </div>
                        </li>
                        <li>
                            <span class="yellow" ref="whiteFn"></span>
                            <div class="info">
                                <span>{{ settled.houseSettledCount - dataList.haveContactHouseNum > 0 ? settled.houseSettledCount - dataList.haveContactHouseNum : 0 || "0" }}</span>
                                <span>已入驻无户代表</span>
                            </div>
                        </li>
                        <li>
                            <span class="blue" ref="whiteFn"></span>
                            <div class="info">
                                <span>{{ dataList.haveContactHouseNum }}</span>
                                <span>已入驻有户代表</span>
                            </div>
                        </li>
                        <!--          <li>-->
                        <!--            <span class="yellow"></span>-->
                        <!--            <div class="info">-->
                        <!--              <span>6</span><span>已入驻无户代表</span>-->
                        <!--            </div>-->
                        <!--          </li>-->
                        <!--          <li>-->
                        <!--            <span class="blue"></span>-->
                        <!--            <div class="info">-->
                        <!--              <span>6</span><span>已入驻有户代表</span>-->
                        <!--            </div>-->
                        <!--          </li>-->
                    </ul>
                </div>
            </div>
            <div class="area" v-if="flag">
                <div class="area-wrapper" v-for="areaItem in dataList.tree" :key="areaItem.id">
                    <span>{{ areaItem.name }}</span>
                    <div class="wrapper-item">
                        <template v-if="areaItem.child !== null">
                            <Card class="cards" v-for="childItem in areaItem.child" :key="childItem.id">
                                <div @click="type1Fn(areaItem, childItem)" :class="childItem.contact === '0' ? 'baise' : childItem.contact === '1' ? 'blue' : 'yellow'">
                                    <p style="height: 30px">
                                        <svg v-if="childItem.regionType === '1'" t="1621307645043" class="icon iconfont1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1589" width="16" height="16">
                                            <path
                                                d="M1007.282671 936.766331h-49.964825V316.915824a46.688443 46.688443 0 0 0-23.344221-40.954774L680.258799 128.319089a46.893216 46.893216 0 0 0-70.442212 40.954774v767.492468h-53.241206V47.023862a46.688443 46.688443 0 0 0-20.477387-39.111809A46.074121 46.074121 0 0 0 491.45729 4.021349L94.810302 174.188436a47.09799 47.09799 0 0 0-28.463568 43.207287v719.370608H16.586684a16.586684 16.586684 0 0 0-16.586684 16.586684v54.060301a16.586684 16.586684 0 0 0 16.586684 16.586684h990.695987a16.586684 16.586684 0 0 0 16.586683-16.586684v-54.060301a16.586684 16.586684 0 0 0-16.586683-16.586684zM739.233674 296.028889a16.586684 16.586684 0 0 1 16.586683-16.586683h52.626885a16.586684 16.586684 0 0 1 16.586684 16.586683V348.246226a16.586684 16.586684 0 0 1-16.586684 16.586684h-52.626885a16.586684 16.586684 0 0 1-16.586683-16.586684z m0 132.693468a16.586684 16.586684 0 0 1 16.586683-16.586683h52.626885a16.586684 16.586684 0 0 1 16.586684 16.586683v52.831659a16.586684 16.586684 0 0 1-16.586684 16.586684h-52.626885a16.586684 16.586684 0 0 1-16.586683-16.586684z m0 132.898243a16.586684 16.586684 0 0 1 16.586683-16.586684h52.626885a16.586684 16.586684 0 0 1 16.586684 16.586684V614.452258a16.586684 16.586684 0 0 1-16.586684 16.586684h-52.626885a16.586684 16.586684 0 0 1-16.586683-16.586684z m0 132.693468a16.586684 16.586684 0 0 1 16.586683-16.586684h52.626885a16.586684 16.586684 0 0 1 16.586684 16.586684v52.626885a16.586684 16.586684 0 0 1-16.586684 16.586683h-52.626885a16.586684 16.586684 0 0 1-16.586683-16.586683z m0 132.693468a16.586684 16.586684 0 0 1 16.586683-16.586683h52.626885a16.586684 16.586684 0 0 1 16.586684 16.586683V880.65829a16.586684 16.586684 0 0 1-16.586684 16.586684h-52.626885a16.586684 16.586684 0 0 1-16.586683-16.586684zM348.11558 163.949742a16.791457 16.791457 0 0 1 16.586684-16.791457h52.831659a16.791457 16.791457 0 0 1 16.586683 16.791457v52.626885a16.586684 16.586684 0 0 1-16.586683 16.586684h-53.241207a16.586684 16.586684 0 0 1-16.586683-16.586684z m0 132.693469a16.586684 16.586684 0 0 1 16.586684-16.586684h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586684V348.246226a16.586684 16.586684 0 0 1-16.586683 16.586684h-53.241207A16.586684 16.586684 0 0 1 348.11558 348.246226z m0 132.693468a16.586684 16.586684 0 0 1 16.586684-16.586683h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586683v52.831659a16.791457 16.791457 0 0 1-16.586683 16.586683h-53.241207a16.791457 16.791457 0 0 1-16.586683-16.586683z m0 132.898242a16.586684 16.586684 0 0 1 16.586684-16.586683h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586683V614.452258a16.586684 16.586684 0 0 1-16.586683 16.586684h-53.241207A16.586684 16.586684 0 0 1 348.11558 614.452258z m0 132.693469a16.586684 16.586684 0 0 1 16.586684-16.586684h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586684v52.626884a16.586684 16.586684 0 0 1-16.586683 16.586684h-53.241207a16.586684 16.586684 0 0 1-16.586683-16.586684z m0 132.693468a16.791457 16.791457 0 0 1 16.586684-16.586684h52.831659a16.791457 16.791457 0 0 1 16.586683 16.586684V880.65829a16.791457 16.791457 0 0 1-16.586683 16.586684h-53.241207A16.791457 16.791457 0 0 1 348.11558 880.65829zM188.187187 296.028889a16.38191 16.38191 0 0 1 16.38191-16.586683h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586683V348.246226a16.586684 16.586684 0 0 1-16.586683 16.586684H204.773871a16.38191 16.38191 0 0 1-16.38191-16.586684z m0 132.693468a16.38191 16.38191 0 0 1 16.38191-16.586683h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586683v52.831659a16.586684 16.586684 0 0 1-16.586683 16.586684H204.773871a16.586684 16.586684 0 0 1-16.38191-16.586684z m0 132.898243a16.38191 16.38191 0 0 1 16.38191-16.586684h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586684V614.452258a16.586684 16.586684 0 0 1-16.586683 16.586684H204.773871a16.38191 16.38191 0 0 1-16.38191-16.586684z m0 132.693468a16.38191 16.38191 0 0 1 16.38191-16.586684h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586684v52.626885a16.586684 16.586684 0 0 1-16.586683 16.586683H204.773871a16.38191 16.38191 0 0 1-16.38191-16.586683z m0 132.693468a16.586684 16.586684 0 0 1 16.38191-16.586683h52.831659a16.586684 16.586684 0 0 1 16.586683 16.586683V880.65829a16.586684 16.586684 0 0 1-16.586683 16.586684H204.773871a16.586684 16.586684 0 0 1-16.38191-16.586684z"
                                                fill="#68C08E"
                                                p-id="1590"
                                            ></path>
                                        </svg>
                                        <svg v-if="childItem.regionType === '2' || childItem.regionType === '3'" t="1621308031034" class="icon iconfont1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1731" width="16" height="16">
                                            <path
                                                d="M287.232 838.144H174.08c-15.36 0-26.112 10.24-26.112 26.112s10.24 26.112 26.112 26.112h675.84c15.36 0 26.112-10.24 26.112-26.112s-10.24-26.112-26.112-26.112H728.064m-51.712 0H338.944m145.408-562.176H432.64v51.712h51.712v-51.712z m119.296 0h-51.712v51.712h51.712v-51.712zM484.352 419.84H432.64v51.712h51.712V419.84z m119.296 0h-51.712v51.712h51.712V419.84zM484.352 558.592H432.64v51.712h51.712v-51.712z m119.296 0h-51.712v51.712h51.712v-51.712zM484.352 722.944H432.64v51.712h51.712v-51.712z m119.296 0h-51.712v51.712h51.712v-51.712z"
                                                fill="#B0B0B0"
                                                p-id="1732"
                                            ></path>
                                            <path
                                                d="M761.856 889.856h-499.2V169.472s-0.512-23.552 4.608-29.184c5.12-5.12 35.328-6.144 35.328-6.144h426.496s23.04 0 28.672 6.144c4.096 5.632 3.584 29.696 3.584 29.696v719.872z m-445.44-51.712h391.68v-650.24h-391.68v650.24z"
                                                fill="#B0B0B0"
                                                p-id="1733"
                                            ></path>
                                        </svg>
                                        <!--                    <span>10号</span>-->
                                    </p>
                                    <p>
                                        {{ childItem.name }}
                                    </p>
                                </div>
                            </Card>
                        </template>
                        <div v-if="areaItem.child === null" style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">暂无数据</div>
                    </div>
                </div>
            </div>
            <Modelover ref="modelValue1" :value="value" :close-fn1="toggle2" :regionType="regionType" :overviewtoggle="overviewtoggle" :dataId="dataId" :communityCode="communityCode" :nameover="nameover" :fullscreen="true" :toggle="toggle"></Modelover>
        </template>
        <!--    <template v-slot:toolsbarBottom>-->
        <!--      <Button class="bot" type="primary" @click="downFn">关闭</Button>-->
        <!--    </template>-->
    </LiefengContentOverView>
</template>

<script lang="js">
//@route('/regionaloverview')

import Modelover from "@/views/overview/modelover";
import LiefengContentOverView from "@/components/LiefengContent3";
// import LiefengContent from "@/components/LiefengContent3";
import store from '@/store/index.js';

export default {
  name: "index.vue",
  components: {
    LiefengContentOverView,
    Modelover
  },
  data() {
    return {
      overviewtoggle:false,
      regionType: '',  //类型
      communityCode: '', //社区编码
      settled: {
            streetCount:0,
            streetSettledCount:0,
            projectCount:0,
            projectSettledCount:0,
            buildingCount:0,
            buildingSettledCount:0,
            houseCount:0,
            initHouseNum:0,
            houseSettledCount:0
      }, //社区总览总数
      dataList: {},
      value: false,
      dataId: '', //id
      nameover: '',
      nameList: [],
      flag: true,
      toggle: true
    }
  },
  created() {
    this.communityCode = this.$route.query.communityCode
    this.nameover = this.$route.query.nameover
    console.log(this.$store.state.buildObj,'created')
    console.log(this.$store.state.buildChild,'created')


  },
  mounted() {
    this.flag = false;
    this.$nextTick(() => {
      this.flag = true
      this.toggleFn()
    })
    if(Object.keys(JSON.parse(JSON.stringify(this.$store.state.buildObj))).length && Object.keys(JSON.parse(JSON.stringify(this.$store.state.buildChild))).length){
      this.type1Fn(this.$store.state.buildObj,this.$store.state.buildChild)
    }
  },
  methods: {
    toggleFn() {
      if(!this.$store.state.buildObj && !this.$store.state.buildChild){
        this.$Message.loading({
          content: "正在加载数据，请稍等...",
          duration: 0,
        });
      }

      //社区总览总数统计
      // this.$get('/syaa/pc/sy/user/online/home/onlineHomeCommunityOverviewCount', {
      //   orgCode: this.communityCode,
      //   oemCode: parent.vue.oemInfo.oemCode
      // }).then(res => {
      //   if (res.code == 200 && res.data) {
      //     this.$Message.destroy()
      //     this.settled = res.data
      //   } else {
      //      this.$Message.destroy()
      //     this.$Message.error({
      //       background: true,
      //       content: res.desc
      //     });
      //   }
      // }).catch(err => {
      //    this.$Message.destroy()
      //   console.log(err)
      // })

      //建设社区总览
      this.$get('/syaa/pc/sy/user/online/home/onlineHomeCommunityOverview', {
        orgCode: this.communityCode,
        oemCode: parent.vue.oemInfo.oemCode
      }).then(res => {
        if (res.code == 200 && res.data) {
          this.$Message.destroy()
          this.dataList=[]
          this.settled ={
             streetCount:res.data.streetCount,
              streetSettledCount:res.data.streetSettledCount,
              projectCount:res.data.projectCount,
              projectSettledCount:res.data.projectSettledCount,
              buildingCount:res.data.buildingCount,
              buildingSettledCount:res.data.buildingSettledCount,
              houseCount:res.data.houseCount,
              initHouseNum:res.data.initHouseNum,
              houseSettledCount:res.data.houseSettledCount
          }
          this.dataList.contactCount = res.data.contactCount  //已入驻户代表数量
          this.dataList.settledCount = res.data.settledCount  //已入驻数量
          this.dataList.unSettledCount = res.data.unSettledCount  //未入驻数量
          this.dataList.haveContactHouseNum = res.data.haveContactHouseNum
          this.dataList.tree = res.data.tree
        } else {
           this.$Message.destroy()
          this.$Message.error({
            background: true,
            content: res.desc
          });
        }
      }).catch(err => {
         this.$Message.destroy()
        console.log(err)
      })
    },
    //打开弹窗
    type1Fn(obj, child) {
      this.$store.commit('changeBuildObj',obj)
      this.$store.commit('changeBuildChild',child)
      this.regionType = child.regionType
      this.dataId = child.id
      if (child.regionType === '1') {
        this.value = true
        this.overviewtoggle=true
        this.$refs.modelValue1.save(obj, child)
        if(this.$store.state.buildObj && this.$store.state.buildChild && this.$store.state.buildHouse){
          console.log(this.$store.state.buildHouse)
          this.$refs.modelValue1.open(this.$store.state.buildHouse, obj.name + child.name)
        }
      }else if(child.regionType === '2' || child.regionType === '3'){
        this.value = true
        this.overviewtoggle=false
        this.$refs.modelValue1.save(obj, child)
        if(this.$store.state.buildObj && this.$store.state.buildChild && this.$store.state.buildHouse){
          console.log(this.$store.state.buildHouse)
          this.$refs.modelValue1.open(this.$store.state.buildHouse, obj.name + child.name)
        }
        console.log('111')
      } else if(child.regionType === '4') {
        this.$refs.modelValue1.open(child.code, obj.name + child.name)
        // console.log('打不开')

        // return
      }

    },
    toggle2() {
      this.value = false
    },
    backClick() {

      this.$router.replace({
        path: '/area',
        query: {
          isLineHome: this.$route.query.isLineHome
        }
      })
      // this.$router.go(-1)
      this.$store.commit('changeBuildObj',{})
      this.$store.commit('changeBuildChild',{})
      this.$store.commit('changeBuildHouse','')
    }
  }
}
</script>

<style scoped lang="less">
.baise {
    background: #ffffff;
}

.yellow {
    background: #ffb800;
}

.blue {
    background: #33cccc;
}

.icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
}

.iconfont {
    font-family: "iconfont" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
}

.iconfont1 {
    width: 31px;
    height: 30px;
}

.white {
    background: #ffffff;
}

.yellow {
    background: #ffb800;
}

.blue {
    background: #33cccc;
}

.bot {
    margin: 0 10px;
}

.header-wrapper {
    .header {
        display: flex;

        /deep/ .ivu-card {
            margin: 0 20px;
        }

        > .cards {
            div {
                > p:nth-child(2) {
                    color: red;
                    font-size: 17px;
                    font-weight: 800;
                    margin: 10px 0;
                }

                > :nth-child(3) {
                    color: #000;
                    font-size: 16px;
                    font-size: 20px;
                }
            }
        }
    }

    .illustrated {
        display: flex;
        margin: 10px 20px;
        box-sizing: border-box;
        background: #f2f2f2;

        > ul {
            box-sizing: border-box;
            display: flex;
            padding: 15px 0;
            font-size: 15px;
            display: flex;
            align-items: center;

            > li {
                display: flex;
                align-items: center;

                &:first-child {
                    margin-right: 20px;
                }

                &:not(:first-child) {
                    margin-right: 40px;
                }

                > span {
                    margin-left: 8px;
                    width: 38px;
                    height: 34px;
                    border: 1px solid #ccc;
                    display: flex;

                    > img {
                        width: 100%;
                        height: 100%;
                        vertical-align: middle;
                    }
                }

                > .info {
                    padding: 0 7px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;

                    > span:first-child {
                        color: red;
                    }
                }
            }
        }
    }
}

.area {
    background: #f3f3f3;
    padding: 10px 0 0px 0;
    margin: 0 20px;
    display: flex;
    flex-direction: column;
    flex: 1;
    //overflow: auto;

    > .area-wrapper {
        display: flex;
        border-bottom: 1px dashed #bee580;
        margin-top: 10px;

        > span {
            font-weight: 800;
            font-size: 19px;
            padding: 0 0 0 10px;
            width: 180px;
        }

        > .wrapper-item {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            min-height: 200px;

            > .cards {
                width: 126px;
                height: 89px;
                margin: 0 0 10px 10px;

                /deep/ .ivu-card-body {
                    padding: 0;
                    width: 100%;
                    height: 100%;

                    > div {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-evenly;
                        align-items: center;
                        width: 100%;
                        height: 100%;

                        > p:first-child {
                            flex: 1;
                            display: flex;
                            align-items: center;
                        }

                        > p:last-child {
                            flex: 1;
                            display: flex;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            line-clamp: 2;
                            -webkit-box-orient: vertical;
                            text-align: center;
                        }
                    }
                }
            }
        }
    }
}

#house {
    display: flex;
    justify-content: space-between;

    > span {
        flex: 1;
    }
}
</style>
